<template>
  <div class="nko-detail-header">
    <div v-if="screenWidth > 1024">
      <breadcrumbs :items="subHeader.breadcrumbs"/>
      <h1 class="nko-detail-header__title">
        {{ subHeader.title }}
      </h1>
    </div>
    <div class="nko-detail-header__aside">
      <NkoCompany />
    </div>
  </div>
</template>

<script>
import {useHeader} from "../../composables/useHeader";
import Breadcrumbs from "../main/Breadcrumbs";

export default {
  name: 'NkoDetailHeader',
  props: ['result'],
  components: {
    Breadcrumbs,
  },
  setup: (props, ctx) => {
    const {subHeader} = useHeader();
    return {
      subHeader
    }
  },
}
</script>

<style lang="scss" scoped>
.nko-detail-header {
  display: grid;
  grid-template-columns: 1fr .48fr;
  grid-column-gap: 73px;
  @include tablet{
    grid-template-columns: 1fr;
  }
  &__title{
    font-family: 'Montserrat';
    font-weight: 600;
    font-size: 32px;
    line-height: 38px;
    @include tablet{
      font-size: 22px;
      line-height: 28px;
    }
  }
  &__aside{
    position: relative;
  }
}
</style>